import { LIKE, UNLIKE } from 'mk/autogenerated/translations/LikeControl.1085c949e04524028515249d4f6afbd3'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { login_url } from 'mk/urls/functions';
import Btn, { BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { likeToggle } from 'mk2/containers/Like/Like.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState, getLikeIsLiked } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './LikeControl.mscss';

interface OwnProps {
    entity: string;
    id: number;
    isLikeable: boolean;

    requestUser: UserEntity;
}

interface StateProps {
    isLiked: boolean;
}

interface DispatchProps {
    onLikeToggle(entityType: string, entityId: number);
}

type Props = OwnProps & StateProps & DispatchProps;

class LikeControl extends React.Component<Props> {

    public render() {
        const { requestUser, isLikeable, isLiked } = this.props;

        if (!isLikeable) {
            return null;
        }

        const text = interpolate(isLiked ? UNLIKE : LIKE);

        return (
            <Btn
                className={styles.LikeControl__btn}
                type={BtnType.BlueTextLight}
                onClick={isAuthenticated(requestUser) ? this.handleOnLike : null}
                link={!isAuthenticated(requestUser) ? login_url({ next: location.pathname }) : null}
                label={text}
                sidePadding={BtnSidePadding.None}
                asAnchor={!isAuthenticated(requestUser)}
            />
        );
    }

    private handleOnLike = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        const { entity, id, onLikeToggle } = this.props;
        onLikeToggle(entity, id);
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        isLiked: getLikeIsLiked(state, ownProps.entity, ownProps.id),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onLikeToggle: likeToggle,
};

export default connect(mapStateToProps, mapDispatchToProps)(LikeControl);
